import { useGetServiceBr } from 'queries';
import { useTranslation } from 'react-i18next';

import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';
import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';
import { isFieldInArrayValueGetter } from 'components/shared/DataGrid/utils/valueGetters/isFieldInArrayValueGetter';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { nestedFieldValueGetter } from 'utils/grid';
import { SurchargesMaintenance } from '../types';
import { GridColDef } from '@mui/x-data-grid-pro';

const useDetailsColumnDefinitions = () => {
  const { t } = useTranslation();
  const { data: serviceBrOptions } = useGetServiceBr();

  return [
    {
      field: 'description',
      headerName: t('surchargesMaintenance.form.description'),
      type: 'string',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'method',
      headerName: t('surchargesMaintenance.form.method'),
      type: 'singleSelect',
      minWidth: 80,
      flex: 1
    },
    {
      field: 'REQUEST_BASED_SERVICE_FLAG',
      headerName: t(
        'surchargesMaintenance.form.flags.REQUEST_BASED_SERVICE_FLAG'
      ),
      type: 'boolean',
      minWidth: 100,
      flex: 1,
      renderCell: BooleanCell,
      valueGetter: (_, row) => isFieldInArrayValueGetter('flags').bind(null, 'REQUEST_BASED_SERVICE_FLAG', row),
    },
    {
      field: 'SERVICE_BR_DEFAULT_FLAG',
      headerName: t('surchargesMaintenance.form.flags.SERVICE_BR_DEFAULT_FLAG'),
      type: 'boolean',
      minWidth: 100,
      flex: 1,
      renderCell: BooleanCell,
      valueGetter: (_, row) => isFieldInArrayValueGetter('flags').bind(null, 'SERVICE_BR_DEFAULT_FLAG', row),

    },
    {
      field: 'serviceBrId',
      headerName: t('surchargesMaintenance.form.serviceBrId'),
      type: 'singleSelect',
      minWidth: 200,
      flex: 1,
      valueOptions: serviceBrOptions,
      valueFormatter: (value: string | number) =>
        singleSelectValueFormatter(value, serviceBrOptions ?? [])
    },
    {
      field: 'surcharge1Duty',
      headerName: t('surchargesMaintenance.form.surcharge1Duty'),
      type: 'number',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'surcharge1Nom',
      headerName: t('surchargesMaintenance.form.surcharge1Nom'),
      type: 'number',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'surcharge1Perc',
      headerName: t('surchargesMaintenance.form.surcharge1Perc'),
      type: 'number',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'surcharge3Duty',
      headerName: t('surchargesMaintenance.form.surcharge3Duty'),
      type: 'number',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'surcharge3Nom',
      headerName: t('surchargesMaintenance.form.surcharge3Nom'),
      type: 'number',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'surcharge3Perc',
      headerName: t('surchargesMaintenance.form.surcharge3Perc'),
      type: 'number',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'valid.from',
      headerName: t('validFrom'),
      flex: 1,
      minWidth: 110,
      type: 'date',
      valueFormatter: dateFormatter,
      valueGetter: (_, row: SurchargesMaintenance) => nestedFieldValueGetter('valid.from', row)
    },
    {
      field: 'valid.to',
      headerName: t('validTo'),
      flex: 1,
      minWidth: 110,
      type: 'date',
      valueFormatter: dateFormatter,
      valueGetter: (_, row: SurchargesMaintenance) => nestedFieldValueGetter('valid.to', row)
    },
    {
      field: 'vatSvc',
      headerName: t('surchargesMaintenance.form.vatSvc'),
      type: 'singleSelect',
      minWidth: 100,
      flex: 1
    }
  ] as GridColDef[];
};

export default useDetailsColumnDefinitions;
